/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Ticker } from 'pixi.js-legacy';

export class Timer {
	protected target = 0;
	protected base = 0;
	protected last = 0;
	protected pausedAt = 0;

	constructor(seconds?: number) {
		this.base = Ticker.shared.lastTime;
		this.last = Ticker.shared.lastTime;
		this.target = seconds || 0;
	}

	public set(seconds: number) {
		this.target = seconds || 0;
		this.base = Ticker.shared.lastTime;
		this.pausedAt = 0;
	}

	public tick() {
		const delta = Ticker.shared.lastTime - this.last;
		this.last = Ticker.shared.lastTime;
		return this.pausedAt ? 0 : delta;
	}

	public delta() {
		return (this.pausedAt || Ticker.shared.lastTime) - this.base - this.target;
	}

	public pause() {
		if (!this.pausedAt) {
			this.pausedAt = Ticker.shared.lastTime;
		}
	}

	public unpause() {
		if (this.pausedAt) {
			this.base += Ticker.shared.lastTime - this.pausedAt;
			this.pausedAt = 0;
		}
	}

	public reset() {
		this.base = Ticker.shared.lastTime;
		this.pausedAt = 0;
	}
}
